<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import { Select } from "element-ui";
export default {
  data: function () {
    return {
      shaidiag: false,
      headData: getdata().headData,
      outlist: [],
      searchdiag: false,
      searchlist: getdata().searchlist,
      dateValue: "",
      searchdata: getdata().searchdata,
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
    };
  },
  mounted() {},
  components: {},
  methods: {
    closeshaidiag() {
      this.shaidiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    submitSearch() {
      // this.pagination.pageNum = 1
      // this.pagination.paginationkey++
      // this.fetchBillDetails()
    },
    outPutIInvResult() {},
    forRefresh() {},
    sizechange(e) {
      this.pagination.pageSize = e;
      // this.fetchBillDetails()
    },
    fetchBillDetails() {},
    currentChange(e) {
      this.pagination.pageNum = e;
      // this.fetchBillDetails()
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      // this.fetchBillDetails()
    },
  },
  created() {},
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
